"use client";

import { c as _c } from "react/compiler-runtime";
import { useHits, useInstantSearch, useSearchBox } from "react-instantsearch";
import { PlpCurrentRefinementsPills } from "@/components/custom/Plp/PlpCurrentRefinementsPills";
import { PlpFilterDrawerButton } from "@/components/custom/Plp/PlpFilterDrawerButton";
import { PlpFilterSidebar } from "@/components/custom/Plp/PlpFilterSidebar";
import { PlpLayout } from "@/components/custom/Plp/PlpLayout";
import { PlpPageHeader } from "@/components/custom/Plp/PlpPageHeader";
import { PRODUCTS_INDEX_NAME } from "@/lib/search/instantsearchClient";
import type { TypesenseHit } from "@/lib/search/types";
import { toProductHit } from "@/lib/search/typesenseInstantsearchHit";
import { PlpResultsBody } from "./PlpResultsBody";
interface Props {
  pageTitle: string;
  productTypeBakedIn?: boolean;
  bakedAttributes?: Readonly<Record<string, string>>;
}
const BAKED_PRODUCT_TYPE_EXCLUSIONS: string[] = ["productType"];
export function PlpResultsView(t0) {
  const $ = _c(35);
  const {
    pageTitle,
    productTypeBakedIn,
    bakedAttributes
  } = t0;
  const {
    query: liveQuery
  } = useSearchBox();
  const {
    items,
    results
  } = useHits();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      catchError: true
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    status,
    setUiState,
    refresh
  } = useInstantSearch(t1);
  const hasQuery = liveQuery.length > 0;
  let t2;
  if ($[1] !== hasQuery || $[2] !== items) {
    let t3;
    if ($[4] !== hasQuery) {
      t3 = item => {
        const hit = toProductHit(item, {
          includeMatched: hasQuery
        });
        return hit ? [hit] : [];
      };
      $[4] = hasQuery;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    t2 = items.flatMap(t3);
    $[1] = hasQuery;
    $[2] = items;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const hits = t2;
  const total = results?.nbHits ?? hits.length;
  const showEmpty = status !== "loading" && status !== "stalled" && hits.length === 0;
  const exclusions = productTypeBakedIn ? BAKED_PRODUCT_TYPE_EXCLUSIONS : undefined;
  const resolvedTitle = hasQuery ? `Search Results for '${liveQuery}'` : pageTitle;
  let t3;
  if ($[6] !== setUiState) {
    t3 = function handleClearSearch() {
      setUiState(_temp);
    };
    $[6] = setUiState;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleClearSearch = t3;
  let t4;
  if ($[8] !== handleClearSearch || $[9] !== hasQuery || $[10] !== liveQuery) {
    t4 = hasQuery ? {
      label: `Search: “${liveQuery}”`,
      onClear: handleClearSearch
    } : undefined;
    $[8] = handleClearSearch;
    $[9] = hasQuery;
    $[10] = liveQuery;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const searchPill = t4;
  let t5;
  if ($[12] !== resolvedTitle) {
    t5 = <PlpPageHeader title={resolvedTitle} />;
    $[12] = resolvedTitle;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  let t7;
  if ($[14] !== bakedAttributes || $[15] !== exclusions) {
    t6 = <PlpFilterSidebar excludeAttributes={exclusions} bakedAttributes={bakedAttributes} />;
    t7 = <PlpFilterDrawerButton excludeAttributes={exclusions} bakedAttributes={bakedAttributes} />;
    $[14] = bakedAttributes;
    $[15] = exclusions;
    $[16] = t6;
    $[17] = t7;
  } else {
    t6 = $[16];
    t7 = $[17];
  }
  let t8;
  if ($[18] !== exclusions || $[19] !== searchPill) {
    t8 = <PlpCurrentRefinementsPills excludedAttributes={exclusions} searchPill={searchPill} />;
    $[18] = exclusions;
    $[19] = searchPill;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== hasQuery || $[22] !== hits || $[23] !== liveQuery || $[24] !== refresh || $[25] !== showEmpty || $[26] !== status || $[27] !== total) {
    t9 = <PlpResultsBody status={status} total={total} showEmpty={showEmpty} hasQuery={hasQuery} liveQuery={liveQuery} hits={hits} onRetry={refresh} />;
    $[21] = hasQuery;
    $[22] = hits;
    $[23] = liveQuery;
    $[24] = refresh;
    $[25] = showEmpty;
    $[26] = status;
    $[27] = total;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  let t10;
  if ($[29] !== t5 || $[30] !== t6 || $[31] !== t7 || $[32] !== t8 || $[33] !== t9) {
    t10 = <PlpLayout header={t5} sidebar={t6}>{t7}{t8}{t9}</PlpLayout>;
    $[29] = t5;
    $[30] = t6;
    $[31] = t7;
    $[32] = t8;
    $[33] = t9;
    $[34] = t10;
  } else {
    t10 = $[34];
  }
  return t10;
}
function _temp(prev) {
  const indexState = prev[PRODUCTS_INDEX_NAME] ?? {};
  const {
    query: _query,
    ...rest
  } = indexState;
  return {
    ...prev,
    [PRODUCTS_INDEX_NAME]: rest
  };
}